import React, { useEffect, useState } from "react";
import "../css2/HelprrSensoryGrounding.css";

const STEPS = [
  { label: "SEE", count: 5, text: "Notice five things you can see around you." },
  { label: "FEEL", count: 4, text: "Notice four sensations in your body." },
  { label: "HEAR", count: 3, text: "Listen for three different sounds." },
  { label: "SMELL", count: 2, text: "Notice two scents, even subtle ones." },
  { label: "GRATEFUL", count: 1, text: "One thing you feel grateful for." },
];

export default function HelprrSensoryGrounding({
  title = "5-4-3-2-1 grounding",
  subtitle = "A gentle way to come back into the present moment.",
  stepDuration = 14000,
}) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (index >= STEPS.length) return;

    const t = setTimeout(() => {
      setIndex(i => i + 1);
    }, stepDuration);

    return () => clearTimeout(t);
  }, [index, stepDuration]);

  const step = STEPS[index];

  return (
    <section className="hsg-card">
      <header className="hsg-header">
        <h3>{title}</h3>
        <p>{subtitle}</p>
      </header>

      <div className="hsg-center">
        {step ? (
          <div key={index} className="hsg-step">
            <div className="hsg-number">{step.count}</div>
            <div className="hsg-label">{step.label}</div>
            <p className="hsg-text">{step.text}</p>
          </div>
        ) : (
          <div className="hsg-end">
            <p>Stay here as long as you want.</p>
            <span>There’s no rush.</span>
          </div>
        )}
      </div>

      {index < STEPS.length && (
        <button
          className="hsg-skip"
          onClick={() => setIndex(i => i + 1)}
        >
          Next →
        </button>
      )}
    </section>
  );
}
